import { useCallback, useEffect, useState } from 'react';

import { getPets } from '@/components/patient/patient-actions';
import { Pet } from '@/db/queries/pets';

export function usePets() {
  const [pets, setPets] = useState<Pet[]>([]);
  const updatePets = useCallback(() => getPets().then(setPets), []);

  useEffect(() => {
    updatePets();
  }, [updatePets]);

  return { pets, updatePets };
}
